'use strict';

console.log("NODE ENV:",process.env.NODE_ENV)
angular.module('client').constant('appConfig',{
  ENV: process.env.NODE_ENV
});
